/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const SortIcon = createIcon({
    displayName: 'SortIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M12 5.802a78.165 78.165 0 0 0-4.84 4.879l-.987-.897c.493-.542.99-1.073 1.489-1.593a77.593 77.593 0 0 1 3.89-3.786L12 4l.448.405a77.634 77.634 0 0 1 3.89 3.786c.5.52.996 1.051 1.489 1.593l-.987.897A78.694 78.694 0 0 0 12 5.802Zm0 12.396a78.067 78.067 0 0 0 4.84-4.879l.987.897c-.493.542-.99 1.073-1.489 1.593a77.594 77.594 0 0 1-3.89 3.786L12 20l-.448-.405a77.61 77.61 0 0 1-3.89-3.786 81.52 81.52 0 0 1-1.489-1.593l.987-.897A78.597 78.597 0 0 0 12 18.198Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M17.064 8.322c.737.767 1.47 1.551 2.196 2.35l1.48-1.345a122.07 122.07 0 0 0-2.232-2.39 117.008 117.008 0 0 0-5.153-5.054 1.985 1.985 0 0 0-2.71 0A117.537 117.537 0 0 0 3.26 9.327l1.48 1.345c.727-.8 1.46-1.583 2.196-2.35A115.143 115.143 0 0 1 12 3.354a115.154 115.154 0 0 1 5.064 4.968Zm-6.418 13.795a1.989 1.989 0 0 0 2.708 0 116.98 116.98 0 0 0 5.154-5.055c.748-.78 1.493-1.576 2.232-2.39l-1.48-1.344c-.727.8-1.46 1.583-2.196 2.35A115.155 115.155 0 0 1 12 20.646a118.232 118.232 0 0 1-7.26-7.319l-1.48 1.346c.739.812 1.484 1.61 2.232 2.39a116.964 116.964 0 0 0 5.154 5.054Z",
            clipRule: "evenodd"
        })
    ]
});
SortIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'SortIcon'
};
export { SortIcon };

//# sourceMappingURL=sort.js.map